<page-load-header *ngIf="!initialized"></page-load-header>

<running-analysis-result-details [isCoachView]="false" [isShared]="true"></running-analysis-result-details>


